import { parse, tokensToRegexp, regexpToFunction, tokensToFunction, } from 'path-to-regexp';
import { getCurrentLocale } from '@tmapy/intl';
import { createComparator } from '@tmapy/utils';
export const routes = [];
const parsePath = (path, preparedOptions, basename) => {
    const fullPath = basename && basename !== '/' ? basename + path : path;
    return parse(fullPath, preparedOptions);
};
const createPreparedOptions = (options) => ({
    decode: decodeURIComponent,
    // encodeURIComponent escapuje dvojtecku, coz rozbije rozpoznavani parametru
    encode: encodeURI,
    ...options,
});
export const getTokensFromPath = (path, options, basename) => {
    const preparedOptions = createPreparedOptions(options);
    return parsePath(path, preparedOptions, basename);
};
export const getLocalizedPath = (pathPrefix, path, lang) => {
    if (!path)
        return;
    if (typeof path === 'string')
        return `${pathPrefix}${path}`;
    return `${pathPrefix}${path[lang ?? 'default'] ?? Object.values(path)[0]}`;
};
const routesByIdLang = new Map();
export const getRouteByIdLang = (id, lang = getCurrentLocale()) => routesByIdLang.get(`${id}:${lang}`) ?? routesByIdLang.get(id);
const registerSingleRoute = (path, routeConfig, options, lang) => {
    const preparedOptions = createPreparedOptions({
        ...options,
        ...routeConfig.options,
    });
    const basename = getLocalizedPath(preparedOptions.pathPrefix ?? '', preparedOptions.basename, lang);
    const tokens = parsePath(path, preparedOptions, basename);
    const keys = [];
    const regexp = tokensToRegexp(tokens, keys, preparedOptions);
    const match = regexpToFunction(regexp, keys, preparedOptions);
    const getHrefWithoutArgs = tokensToFunction(tokens, {
        ...preparedOptions,
        encode: encodeURIComponent,
    });
    const getHref = (data) => {
        const restParams = [];
        if (data) {
            for (const [param, value] of Object.entries(data)) {
                if (value !== undefined && !tokens.find((token) => token?.name === param)) {
                    if (Array.isArray(value)) {
                        value.forEach((val) => restParams.push(`${param}=${encodeURIComponent(val)}`));
                    }
                    else {
                        restParams.push(`${param}=${encodeURIComponent(value)}`);
                    }
                }
            }
        }
        // because of NPM history package BUG - need '?' in every request
        // when fix, edit useLink.ts too
        // https://github.com/ReactTraining/history/issues/814
        return getHrefWithoutArgs(data) + '?' + (restParams.length ? restParams.join('&') : '');
    };
    const route = { ...routeConfig, tokens, lang, regexp, getHref, match, keys };
    routes.push(route);
    routesByIdLang.set(lang ? `${routeConfig.id}:${lang}` : routeConfig.id, route);
};
export const registerRoute = (routeConfig, options) => {
    const basenameLangs = options?.basename && typeof options?.basename !== 'string'
        ? Object.keys(options?.basename)
        : [undefined];
    basenameLangs.forEach((basenameLang) => {
        if (typeof routeConfig.path === 'string') {
            registerSingleRoute(routeConfig.path, routeConfig, options, basenameLang);
        }
        else {
            Object.entries(routeConfig.path).forEach(([lang, urlTemplate]) => {
                if (!basenameLang || basenameLang === lang) {
                    registerSingleRoute(urlTemplate, routeConfig, options, lang);
                }
            });
        }
    });
};
const routeComparator = createComparator((a) => a.tokens.filter((token) => typeof token !== 'string').length, (_, b) => b.tokens.reduce((agr, token) => agr + (typeof token === 'string' ? token.length : 1), 0));
export const sortRoutes = () => {
    routes.sort(routeComparator);
};
export const registerRoutes = (routeConfigs, options) => {
    routeConfigs.forEach((routeConfig) => {
        registerRoute(routeConfig, options);
    });
    sortRoutes();
};
export const matchRoute = (path) => {
    const result = [];
    routes.forEach((route) => {
        const match = route.match(path);
        if (match) {
            result.push({ ...route, ...match });
        }
    });
    return result;
};
//# sourceMappingURL=routes.js.map